import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import api from '../lib/api';
import { useAuth } from './AuthContext';

const EntitlementsContext = createContext(null);

const EMPTY = { modules: {}, addons: [], plan: null, plan_label: '', all_included: false };

export function EntitlementsProvider({ children }) {
  const { isAuthenticated, selectedChurchId } = useAuth();
  const [entitlements, setEntitlements] = useState(EMPTY);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(() => {
    if (!isAuthenticated) {
      setEntitlements(EMPTY);
      setLoading(false);
      return;
    }
    setLoading(true);
    api.get('/api/subscriptions/entitlements', { params: { church_id: selectedChurchId } })
      .then(res => setEntitlements(res.data || EMPTY))
      .catch(() => setEntitlements(EMPTY))
      .finally(() => setLoading(false));
  }, [isAuthenticated, selectedChurchId]);

  useEffect(() => { refresh(); }, [refresh]);

  const hasModule = useCallback(
    (key) => entitlements.all_included || Boolean(entitlements.modules?.[key]),
    [entitlements]
  );

  return (
    <EntitlementsContext.Provider value={{ ...entitlements, loading, hasModule, refresh }}>
      {children}
    </EntitlementsContext.Provider>
  );
}

export const useEntitlements = () => {
  const context = useContext(EntitlementsContext);
  if (!context) throw new Error('useEntitlements must be used within EntitlementsProvider');
  return context;
};
